/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import PropTypes from "prop-types";

export default function CampTextForm(props) {
  const { label, value } = props;
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  return (
    <TextField
      id="outlined-read-only-input"
      fullWidth 
      label={label}
      defaultValue={inputValue}
      InputProps={{
        readOnly: true,
      }}
    />
  );
}

CampTextForm.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};
